/**
 * The BCP 47 locale dates and numbers are formatted in.
 *
 * Kept apart from `i18n/index.ts` so `utils/timezone.ts` can read it without
 * pulling the translation catalogue into every unit test. `index.ts` moves it
 * whenever the language changes.
 *
 * English is `en-AU`, not `en`: the formatters have always printed
 * "16 Mar 2024", and plain `en` prints "Mar 16, 2024".
 */
let current = 'en-AU';

export function displayLocale(): string {
  return current;
}

export function setDisplayLocale(language: string): void {
  current = !language || language === 'en' ? 'en-AU' : language;
}
